import { api } from "../../../../helper/api";
import { mConstants } from "../../../../helper/constants";
import { MPagination } from "../../../../helper/pagination";
import {
  Customer,
  CustomerInquiry,
  CustomerUI,
} from "../entity/customer.model";

async function getCustomers(
  inquiry: CustomerInquiry
): Promise<MPagination<CustomerUI>> {
  let page: MPagination<CustomerUI> = await api.get(
    `${mConstants.ORDER_URL}/customers`,
    {
      params: inquiry,
    }
  );

  page.results.forEach((element) => {
    element.label = element.name;
    element.value = element.uuid;
  });

  return page;
}

function getCustomer(uuid: string): Promise<Customer> {
  return api.get(`${mConstants.ORDER_URL}/customers/${uuid}`);
}

function editCustomer(customer: Customer): Promise<void> {
  return api.put(`${mConstants.ORDER_URL}/customers`, customer);
}

export const customerService = {
  getCustomers,
  getCustomer,
  editCustomer,
};
